import { AcquireTokenFunction, BannerProvider } from "@sbb-rsu/ui-banners";
import { environment } from "models/Environment";
import { useAuthentication } from "providers/Authentication/useAuthentication";
import React, { PropsWithChildren, useCallback } from "react";

export const AppBannerProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { acquireTokenSilent } = useAuthentication();

  const acquireToken = useCallback<AcquireTokenFunction>(
    (scopes: string[]) => acquireTokenSilent(scopes),
    [acquireTokenSilent]
  );

  return (
    <BannerProvider app="edecide" environment={environment.shortName} acquireToken={acquireToken}>
      {children}
    </BannerProvider>
  );
};
